import {useAppDispatch, useAppSelector} from "../../hooks";
import styles from "./StudyContent.module.scss";
import {setProjectTitle, setQueryTitle} from "./cohortBuilderSlice";
import {Project} from "../../types/Project";
import {Query} from "../HealthcareUsageReport/types/CohortQuery";
import React from "react";
import {Typography} from "antd";
import {selectUser} from "../../actions/userSlice";

const { Title } = Typography

type StudyTitlesProps = {
    project: Project
    study: Query
    containerWidth: number
}

export const StudyTitles: React.FC<StudyTitlesProps> = ({ project, study }) => {
    const dispatch = useAppDispatch()
    const user = useAppSelector(selectUser)
    const canEdit = user !== undefined && user.username.toUpperCase() === project.loginId.toUpperCase()

    return <div className={styles['study-titles']} data-testid="study-titles">
        <div>
            <Title
                level={4}
                ellipsis={{
                    rows: 1
                }}
                editable={canEdit ? {
                    maxLength: 100,
                    triggerType: ['text', 'icon'],
                    onChange: (value: string) => {
                        dispatch(setProjectTitle(value));
                    },
                } : false}
                data-testid="project-title"
            >
                {project.title}
            </Title>
        </div>
        <div className={styles['study-title']}>
            <Title
                level={5}
                ellipsis={{
                    rows: 1
                }}
                editable={canEdit ? {
                    maxLength: 100,
                    triggerType: ['text', 'icon'],
                    onChange: (value: string) => {
                        dispatch(setQueryTitle({queryId: study.id, title: value}));
                    },
                } : false}
                data-testid="cohort-title"
            >
                {study.title}
            </Title>
        </div>
    </div>
}
